import {
    CONTENT_FLOW_SET_WORKFLOWS,
    CONTENT_FLOW_SET_META_DEFINITIONS,
    CONTENT_FLOW_SET_LAYOUT_TEMPLATES,
    CONTENT_FLOW_SET_SSTS_VALUES,
    CONTENT_FLOW_SET_GENERAL_SETTINGS,
    CONTENT_FLOW_SET_SETTING_PANELS,
    CONTENT_FLOW_SET_COLLECTIONS,
} from "../actions/content-flow";

const defaultState = {
    workflows: [],
    metaProperties: {},
    layouts: {},
    ssts: [],
    settings: {},
    panels: [],
};

export function contentFlow(state = defaultState, action) {
    switch (action.type) {
        case CONTENT_FLOW_SET_WORKFLOWS:
            return Object.assign({}, state, {
                workflows: action.payload.items,
            });
        case CONTENT_FLOW_SET_COLLECTIONS:
            return Object.assign({}, state, {
                collections: action.payload.items,
            });
        case CONTENT_FLOW_SET_META_DEFINITIONS:
            return Object.assign({}, state, {
                metaProperties: action.payload.items,
            });
        case CONTENT_FLOW_SET_LAYOUT_TEMPLATES:
            return Object.assign({}, state, {
                layouts: action.payload.items,
            });
        case CONTENT_FLOW_SET_SSTS_VALUES:
            return Object.assign({}, state, {
                ssts: action.payload.items,
            });
        case CONTENT_FLOW_SET_GENERAL_SETTINGS:
            return Object.assign({}, state, {
                settings: action.payload.items,
            });
        case CONTENT_FLOW_SET_SETTING_PANELS:
            return Object.assign({}, state, {
                panels: action.payload.items,
            });
        default:
            return state;
    }
}
